// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "dca204f1486dd8a14e5ed25382d63a965bbfb78c/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};